export default "__VITE_ASSET__DxGq20wF__"